import React from 'react';
// eslint-disable-next-line import/order
import { GasV3Integration as BaseGasV3Integration } from '../events/gasv3/bridge';
import { SentryBrowserIntegration as BaseSentryBrowserIntegration } from '../events/sentry-browser/bridge';
import { GasV3OperationalEventListener, GasV3ScreenEventListener, GasV3TrackEventListener, GasV3UIEventListener, SentryExceptionListener } from '../listeners';
export var GasV3Integration = function GasV3Integration(_ref) {
  var children = _ref.children,
    client = _ref.client;
  return /*#__PURE__*/React.createElement(BaseGasV3Integration, {
    client: client,
    GasV3OperationalEventListener: GasV3OperationalEventListener,
    GasV3ScreenEventListener: GasV3ScreenEventListener,
    GasV3TrackEventListener: GasV3TrackEventListener,
    GasV3UIEventListener: GasV3UIEventListener
  }, children);
};
export var SentryBrowserIntegration = function SentryBrowserIntegration(_ref2) {
  var children = _ref2.children,
    client = _ref2.client;
  return /*#__PURE__*/React.createElement(BaseSentryBrowserIntegration, {
    client: client,
    Listener: SentryExceptionListener
  }, children);
};